import * as rasterizeHTML from 'rasterizehtml';
import { getServerURL } from '../../../../../../../Utils/getServerURL';
import { ExportToPDFFnType } from '../../../../../../../Components/ExportToPDF/ExportToPDF';
import { IFakturaBildPDF } from '../../../../../../../Components/ExportToPDF/ExportToPDFArgumentTypes';
import { FakturabildFormat } from './Queries/VerifikationQuery/VerifikationQuery';

export const convertHtmlFakturaToBase64PNG = (
  html: string,
  format?: FakturabildFormat
) => {
  const canvas = document.createElement('CANVAS') as HTMLCanvasElement;

  if (format === 'KOB') {
    canvas.width = 742;
    canvas.height = 1000;
  } else {
    canvas.width = 2480;
    canvas.height = 3508;
  }

  return rasterizeHTML
    .drawHTML(html, canvas, {
      baseUrl: getServerURL(),
      zoom: format === 'KOB' ? 1 : 2,
    })
    .then(() => {
      return canvas.toDataURL('image/png');
    });
};

const openANewWindowAndPrint = (
  html: string,
  verifikationsNr: string,
  setLoading?: (loading: boolean) => void
) => {
  setLoading?.(true);
  const newWindow = window.open(
    '',
    '_blank',
    'toolbar=yes,scrollbars=yes,resizable=yes'
  );

  if (newWindow) {
    newWindow.document.write(html);

    const styling = newWindow.document.createElement('style');

    if (verifikationsNr) {
      const vernrContainer = newWindow.document.createElement('div');
      vernrContainer.classList.add('vernr-container');
      vernrContainer.innerHTML = verifikationsNr
        ? `<p>Verifikationsnr: ${verifikationsNr}</p>`
        : '';
      newWindow.document.body.prepend(vernrContainer);
    }

    if (styling) {
      styling.innerHTML = `
      .vernr-container {
        display: none;
      }

      @media print {
        table {
          margin-top: 12px;
        }
        tr {
          page-break-inside: avoid;
        }
        nav{
          display: none;
        }

        .vernr-container{
          position: absolute;
          top: -12px;
          right: 2px;
          display: flex;
          justify-content: flex-end;
          font-size: 16px;
        }
      }
    `;

      newWindow?.document.body.appendChild(styling);
    }

    newWindow.print();
    setLoading?.(false);
    newWindow.close();
  }
};

export const printFakturabild = (
  exportFakturaImageToPDF: ExportToPDFFnType<IFakturaBildPDF>,
  fakturaBilder: string[],
  verifikationsNr: string,
  xmlFaktura: boolean,
  dbName: string,
  bokfDatum: string,
  journalNr: string,
  skannadSvefaktura: boolean,
  setLoading?: (loading: boolean) => void,
  format?: FakturabildFormat
) => {
  if (xmlFaktura) {
    fetch(`${getServerURL()}/blob?id=${fakturaBilder[0]}`, {
      method: 'post',
      credentials: 'include',
    })
      .then(res => res.text())
      .then(html => {
        if (skannadSvefaktura) {
          exportFakturaImageToPDF(
            {
              reportName: 'Fakturabild',
              dbname: dbName,
              verifikationsNr: verifikationsNr,
              fileName: 'fakturabild_' + verifikationsNr,
              fakturaBildIds: fakturaBilder,
              xmlFaktura,
              bokfDatum,
              journalNr,
              skannadSvefaktura,
            },
            setLoading
          );
        } else {
          if (format === 'KOB') {
            convertHtmlFakturaToBase64PNG(html, format).then(imageData =>
              exportFakturaImageToPDF(
                {
                  reportName: 'Fakturabild',
                  dbname: dbName,
                  verifikationsNr: verifikationsNr,
                  fileName: 'fakturabild_' + verifikationsNr,
                  fakturaBildIds: fakturaBilder,
                  xmlFaktura,
                  base64ImgData: imageData,
                  bokfDatum,
                  journalNr,
                  skannadSvefaktura: false,
                },
                setLoading
              )
            );
          } else {
            openANewWindowAndPrint(html, verifikationsNr, setLoading);
          }
        }
      })
      .catch(err => setLoading?.(false));
  } else {
    exportFakturaImageToPDF(
      {
        reportName: 'Fakturabild',
        dbname: dbName,
        verifikationsNr: verifikationsNr,
        fileName: 'fakturabild_' + verifikationsNr,
        fakturaBildIds: fakturaBilder,
        xmlFaktura,
        bokfDatum,
        journalNr,
        skannadSvefaktura: false,
      },
      setLoading
    );
  }
};
